<template>
    <div class="container-fluid">
        <Breadcrumb title="SMTP Relays" button-url="smtpRelayCreate"></Breadcrumb>
        <div class="row" style="position: relative">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="form-group mb-0">
                            <button type="button" class="btn btn-info btn-rounded mr-2 mb-2"
                                    @click="bulkMove()"
                                    v-bind:disabled="!selectedRelays.length">
                                <i class="fas fa-share"></i>
                                Move to Group
                            </button>
                            <button type="button" class="btn btn-info btn-rounded mr-2 mb-2"
                                    @click="bulkActivity()"
                                    v-bind:disabled="!selectedRelays.length">
                                <i class="fa fa-edit"> </i>
                                Change Activity
                            </button>
                            <button type="button" class="btn btn-danger btn-rounded mr-2 mb-2"
                                    @click="bulkDelete()"
                                    v-bind:disabled="!selectedRelays.length">
                                <i class="far fa-trash-alt"></i>
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body">
                        <div class="input-group form-group">
                            <div class="form-group" v-if="this.$store.getters.isAdmin">
                                <treeselect placeholder="Search by owner"
                                            v-model="userSearch"
                                            :multiple="false"
                                            :options="userList"
                                            :load-options="loadUserList"
                                />
                            </div>
                            <div class="form-group">
                                <treeselect placeholder="Search by group"
                                            v-model="groupSearch"
                                            :multiple="false"
                                            :options="groupList"
                                            :load-options="loadGroupList"
                                            :disabled="Boolean(this.groupId)"
                                />
                            </div>
                            <div class="form-group">
                                <treeselect placeholder="Search by SMTP server"
                                            v-model="serverSearch"
                                            :multiple="false"
                                            :options="serverList"
                                            :load-options="loadServerList"
                                            :disabled="Boolean(this.serverId)"
                                />
                            </div>
                            <input v-model="accountSearch" type="text" class="form-control form-control-line"
                                   placeholder="Search by account">
                            <div class="input-group-append">
                                <button v-on:click="search" class="btn btn-info" type="button">Search</button>
                            </div>
                        </div>
                        <div class="form-group mx-sm-3 mb-2">
                                <span>Total:
                                    <span class="label label-info">{{totalItems}}</span>
                                </span>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-12" v-if="loading" style="min-height:100px;">
                            <Preloader v-bind:class="{preloader: loading}"></Preloader>
                        </div>
                        <div v-else>
                            <div v-if="relayList.length > 0">
                                <div id="bulkMoveHtml" v-show="false">
                                    <select class="form-control" v-model="bulkGroupSelect" ref='bulkMoveHtml'>
                                        <option disabled value="null">Select group</option>
                                        <option v-for="(group, index) in groupList" :key="index" v-bind:value="group.id">{{group.label}}</option>
                                    </select>
                                </div>
                                <div id="bulkActivityHtml" v-show="false">
                                    <select class="form-control" v-model="bulkActivitySelect" ref='bulkActivityHtml'>
                                        <option disabled value="null">Select status</option>
                                        <option value="true">Active</option>
                                        <option value="false">Inactive</option>
                                    </select>
                                </div>
                                <div class="table-responsive">
                                    <table class="table">
                                        <thead>
                                        <tr>
                                            <th><input type="checkbox" v-model="selectAllRelays" @click="selectAll()"></th>
                                            <th @click="tableOrdering('id')">
                                                <span role='button'>ID</span>
                                            </th>
                                            <th @click="tableOrdering('group.name')">
                                                <span role='button'>Group</span>
                                            </th>
                                            <th @click="tableOrdering('smtpServer.name')">
                                                <span role='button'>SMTP server</span>
                                            </th>
                                            <th @click="tableOrdering('account')">
                                                <span role='button'>Account</span>
                                            </th>
                                            <th @click="tableOrdering('status')"><span role='button'>Status</span></th>
                                            <th @click="tableOrdering('active')"><span role='button'>Active</span></th>
                                            <th>Actions</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr :key="index" v-for="(relay, index) in relayList">
                                            <td class="align-middle">
                                                <input type="checkbox" v-model="selectedRelays" :value="relay.id">
                                            </td>
                                            <td class="align-middle">{{relay.id}}</td>
                                            <td class="align-middle">{{relay.group.name}}</td>
                                            <td class="align-middle">{{relay.smtpServer.name}}</td>
                                            <td class="align-middle">{{relay.account}}</td>
                                            <td class="align-middle">{{statuses[relay.status]}}</td>
                                            <td class="align-middle">{{relay.active}}</td>
                                            <td class="align-middle">
                                                <router-link :to="{ name: 'smtpRelayEdit', params: { id: relay.id }}"
                                                             class="btn btn-sm btn-info m-r-10">
                                                    <i class="fa fa-edit"></i> Edit
                                                </router-link>
                                                <button @click="deleteRelay(relay.id)" class="btn btn-sm btn-danger"
                                                        type="button">
                                                    <i class="far fa-trash-alt"></i> Delete
                                                </button>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <paginate :click-handler="getItems"
                                          :container-class="'pagination justify-content-center'"
                                          :margin-pages="2"
                                          :next-class="'page-item'"
                                          :next-link-class="'page-link'"
                                          :next-text="'Next'"
                                          :page-class="'page-item'"
                                          :page-count="pageCount"
                                          :page-link-class="'page-link'"
                                          :page-range="3"
                                          :prev-class="'page-item'"
                                          :prev-link-class="'page-link'"
                                          :prev-text="'Prev'"
                                          v-if="pageCount > 1"
                                          v-model="page">
                                </paginate>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Swal from 'sweetalert2';
    import SmtpRelayService from '../services/SmtpRelayService';
    import UserService from '../services/UserService';
    import SmtpRelayGroupService from '../services/SmtpRelayGroupService';
    import Preloader from '../components/Preloader';
    import Breadcrumb from '../components/Breadcrumb';
    import SmtpServerService from '../services/SmtpServerService';
    import Treeselect from '@riophae/vue-treeselect';
    import paginateMixin from '../mixins/paginate-mixin';
    import {RelayStatus} from '../constants';

    export default {
        name: 'SmtpRelays',
        props: ['serverId', 'groupId'],
        components: {
            Preloader, Breadcrumb, Treeselect
        },
        mixins: [paginateMixin],
        data() {
            return {
                orderField: 'id',
                orderDirection: 'asc',
                accountSearch: null,
                relayList: [],
                userSearch: null,
                userList: null,
                groupSearch: null,
                groupList: null,
                serverSearch: null,
                serverList: null,
                loading: false,
                totalItems: 0,
                page: 1,
                perPage: paginateMixin.defaultPerPage,
                statuses: RelayStatus.value,
                buttons: RelayStatus.buttons,
                selectedRelays: [],
                selectAllRelays: false,
                bulkGroupSelect: null,
                bulkActivitySelect: null
            }
        },
        mounted() {
            this.getItems(this.page = 1);
        },
        methods: {
            getItems: function (pageNum) {
                this.selectedRelays = [];
                this.selectAllRelays = false;
                this.loading = true;
                SmtpRelayService.getRelays(
                    pageNum,
                    this.perPage,
                    this.orderField,
                    this.orderDirection,
                    this.accountSearch,
                    this.userSearch,
                    this.groupId ? this.groupId : this.groupSearch,
                    this.serverId ? this.serverId : this.serverSearch
                ).then(response => {
                    this.relayList = response.data['hydra:member'];
                    this.totalItems = response.data['hydra:totalItems'];
                    this.loading = false;
                });
            },
            search: function () {
                this.getItems(this.page = 1);
            },
            deleteRelay(id) {
                Swal({
                    title: 'Are you sure you want to delete?',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Confirm',
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return SmtpRelayService.deleteRelay(id).then((response) => {
                            if (response.status === 204) {
                                let relayIndex = this.relayList.findIndex(obj => obj.id === id);
                                this.relayList.splice(relayIndex, 1);
                                this.totalItems--;
                            }
                        });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value) {
                        Swal(
                            'Deleted successfully!',
                            `Relay has been deleted.`,
                            'success'
                        )
                    }
                })
            },
            tableOrdering(field) {
                if (this.orderField === field) {
                    this.orderDirection = (this.orderDirection === 'asc') ? 'desc' : 'asc';
                } else {
                    this.orderField = field;
                    this.orderDirection = 'asc';
                }
                this.getItems(this.page = 1);
            },
            loadUserList({callback}) {
                UserService.getUserSelect().then(response => {
                    this.userList = response.data['hydra:member'].map(user => {
                        return {id: user.id, label: user.username}
                    });
                    callback();
                });
            },
            loadGroupList({callback}) {
                SmtpRelayGroupService.getGroupSelect().then(response => {
                    this.groupList = response.data['hydra:member'].map(group => {
                        return {id: group.id, label: group.name}
                    });
                    callback(this.groupSearch = this.groupId);
                });
            },
            loadServerList({callback}) {
                SmtpServerService.getServerSelect().then(response => {
                    this.serverList = response.data['hydra:member'].map(server => {
                        return {id: server.id, label: server.name}
                    });
                    callback(this.serverSearch = this.serverId);
                });
            },
            selectAll() {
                this.selectedRelays = [];
                if (!this.selectAllRelays) {
                    for (let relay of this.relayList) {
                        this.selectedRelays.push(relay.id);
                    }
                }
            },
            bulkMove() {
                Swal({
                    type: 'question',
                    title: 'Which group to move to?',
                    html: this.$refs.bulkMoveHtml,
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return SmtpRelayService.bulkMove(this.selectedRelays, this.bulkGroupSelect).catch(error => {
                            Swal.showValidationMessage('Error: ' + error.response.data.error[0]);
                        });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value.status === 200) {
                        Swal('Successfully moved!');
                        this.getItems(this.page = 1);
                    } else {
                        Swal(result.value.statusText, result.value.data.error[0]);
                    }
                })
            },
            bulkActivity() {
                Swal({
                    type: 'question',
                    title: 'What status to assign?',
                    html: this.$refs.bulkActivityHtml,
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return SmtpRelayService.bulkActivity(this.selectedRelays, this.bulkActivitySelect).catch(error => {
                            Swal.showValidationMessage('Error: ' + error.response.data.error[0]);
                        });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value.status === 200) {
                        Swal('Successfully changed!');
                        this.getItems(this.page = 1);
                    } else {
                        Swal(result.value.statusText, result.value.data.error[0]);
                    }
                })
            },
            bulkDelete() {
                Swal({
                    type: 'question',
                    title: 'Are you sure you want to delete ' + this.selectedRelays.length + ' selected relays?',
                    showCancelButton: true,
                    confirmButtonText: 'Confirm',
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return SmtpRelayService.bulkDelete(this.selectedRelays).catch(error => {
                            Swal.showValidationMessage('Error: ' + error.response.data.error[0]);
                        });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value.status === 200) {
                        Swal('Deleted successfully!');
                        this.getItems(this.page = 1);
                    } else {
                        Swal(result.value.statusText, result.value.data.error[0]);
                    }
                })
            }
        },
        computed: {
            pageCount: function () {
                return Math.ceil(this.totalItems / this.perPage);
            }
        }
    }
</script>

<style scoped>

</style>